import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';

export const onboardingVerifyAccountRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  path: '/verify_account',
}).lazy(() =>
  import('pages/shared/Onboarding/VerifyAccount/VerifyAccountPage').then((d) => d.Route)
);
